import PageWeb from "./PageWeb";

export default PageWeb;
